import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeBubble extends Shape {
    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width - 2 * horizontalPadding;
        const allowedHeight = height - height / 5 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY =
            y + (height * 4) / 5 / 2 - textPart.height / 2 + textPart.lines[0].textHeight;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 8;

        if (width < 6 * r) r = width / 6;
        if (height < 6 * r) r = height / 6;

        // высота выступающей части height/5
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + width, y, x + width, y + (height * 4) / 5, r);
        canv.ctx.arcTo(x + width, y + (height * 4) / 5, x, y + (height * 3) / 4, r);
        canv.ctx.lineTo(x + (width * 2) / 6, y + (height * 4) / 5);
        canv.ctx.lineTo(x + width / 6, y + height);
        canv.ctx.lineTo(x + width / 6, y + (height * 4) / 5);
        canv.ctx.arcTo(x, y + (height * 4) / 5, x, y, r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M13.7193 19.7664H13.5398L13.4013 19.8805L8.12177 24.2318L8.12163 24.2319C7.94363 24.3788 7.73242 24.4681 7.51259 24.4929C7.29294 24.5177 7.07012 24.4774 6.86887 24.375C6.66735 24.2723 6.49405 24.1106 6.37129 23.9051C6.24838 23.6994 6.18202 23.4595 6.18182 23.2129V20.2664V19.7664H5.68182C5.00473 19.7664 4.33369 19.6265 3.70677 19.3541C3.07974 19.0816 2.50843 18.6815 2.02609 18.1755L2.02607 18.1755C1.05148 17.1531 0.5 15.7615 0.5 14.3057V5.9607C0.5 4.50491 1.05147 3.11328 2.02609 2.09084L2.02609 2.09084C2.99992 1.0692 4.31546 0.5 5.68182 0.5H19.3182C19.9952 0.5 20.6663 0.639873 21.2932 0.912301C21.9202 1.18477 22.4915 1.58481 22.9739 2.09084L23.3358 1.74585L22.9739 2.09084C23.4563 2.5969 23.8401 3.19898 24.1024 3.86327C24.3648 4.52757 24.5 5.24034 24.5 5.9607V14.3057C24.5 15.026 24.3648 15.7388 24.1024 16.4031C23.8401 17.0673 23.4563 17.6694 22.9739 18.1755C22.4915 18.6815 21.9202 19.0816 21.2932 19.3541C20.6663 19.6265 19.9953 19.7664 19.3182 19.7664H13.7193Z"/>
            </svg>
        `;
    }
}
